//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

export const DEFAULT_EMPTY_VALUE = '--';
